import { Tab, Tabs } from '@ds';
import { UseFiltersType } from '@/hooks/useFilters';
import { EmployeeListFilters, EmployeeStatus } from '@/api/apis/resources';

type ContractorFiltersProps = UseFiltersType<EmployeeListFilters>;

export const ContractorFilters = ({ filters, updateFilters }: ContractorFiltersProps) => {
  return (
    <div className="flex gap-7 items-center">
      <Tabs
        radius="full"
        aria-label="employee status filter"
        selectedKey={filters.status}
        onSelectionChange={(value) => updateFilters(value as EmployeeStatus, 'status')}
        classNames={{
          tabList: 'bg-base-50 p-0 gap-0',
          tabContent: 'px-2 text-s-sb group-data-[selected=true]:text-base-90',
          cursor: 'bg-base-5',
        }}
      >
        <Tab key={EmployeeStatus.All} title="All" />
        <Tab key={EmployeeStatus.Active} title="Active" />
        <Tab key={EmployeeStatus.Inactive} title="Inactive" />
      </Tabs>
    </div>
  );
};
